import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { gcApi } from 'config/axios';

import {
    FETCH_WORKOUTS,
    FETCH_WORKOUTS_FETCHING,
    FETCH_WORKOUTS_FINISHED,
    FETCH_PROVIDER_WORKOUTS,
    FETCH_PROVIDER_WORKOUTS_FETCHING,
    FETCH_PROVIDER_WORKOUTS_FINISHED,
    FETCH_WHEELCHAIR_WORKOUTS,
    FETCH_WHEELCHAIR_WORKOUTS_FETCHING,
    FETCH_WHEELCHAIR_WORKOUTS_FINISHED
} from '../actions/ActionTypes';

import { mobilityRoleKey } from 'models/preferences/PreferencesMapping'; //clean up ticket CA-175696
import { mobilityPathSuffix } from 'WorkoutPage/utils/WorkoutUtil';

export function* fetchWorkouts(action) {
    const { start, limit, myWorkoutsOnly, sharedWorkoutsOnly, workoutProvider } = action.payload;

    try {
        yield put({
            type: FETCH_WORKOUTS_FETCHING
        });

        let url = `/workout-service/workouts?start=${start}&limit=${limit}&myWorkoutsOnly=${myWorkoutsOnly}&sharedWorkoutsOnly=${sharedWorkoutsOnly}`;

        if (workoutProvider) {
            url += `&workoutProvider=${workoutProvider}`;
        }

        const response = yield call(gcApi.get, url);

        yield put({
            type: FETCH_WORKOUTS_FINISHED,
            workouts: response.data,
            receivedAt: Date.now()
        });
    } catch (e) {}
}

export function* fetchProviderWorkouts(action) {
    const { locale, viewerSocialProfile } = action.payload;
    let url = '';
    try {
        yield put({
            type: FETCH_PROVIDER_WORKOUTS_FETCHING
        });

        if (viewerSocialProfile) {
            const mobilityPreferenceResponse = yield call(axios.get, `/preference/${mobilityRoleKey}`, {
                baseURL: '/modern'
            });
            const mobilityWorkoutsRole = mobilityPreferenceResponse.data;

            const showMobilityWorkouts =
                viewerSocialProfile.userRoles &&
                mobilityWorkoutsRole.value &&
                viewerSocialProfile.userRoles.indexOf(mobilityWorkoutsRole.value) >= 0;

            url = `/web-data/workouts/${locale}/index${showMobilityWorkouts ? mobilityPathSuffix : ''}.json`;
        } else {
            url = `/web-data/workouts/${locale}/index.json`;
        }

        const response = yield call(axios.get, url, { baseURL: '/' });

        yield put({
            type: FETCH_PROVIDER_WORKOUTS_FINISHED,
            workouts: response.data.workouts,
            bodyParts: response.data.bodyParts,
            primaryMuscles: response.data.primaryMuscles,
            goals: response.data.goals,
            sportTypes: response.data.sportTypes,
            difficultyMapper: response.data.difficulty,
            equipment: response.data.equipment,
            receivedAt: Date.now()
        });
    } catch (e) {
        if (locale !== 'en-US') {
            yield call(fetchProviderWorkouts, {
                payload: {
                    locale: 'en-US',
                    viewerSocialProfile
                }
            });
        }
    }
}

export function* fetchWheelchairWorkouts(action) {
    const { locale, viewerSocialProfile } = action.payload;
    let url = '';
    try {
        yield put({
            type: FETCH_WHEELCHAIR_WORKOUTS_FETCHING
        });

        url = `/web-data/workouts/${locale}/index_wheelchair_12_2024_3a5e3d62-6ea4-43ad-b562-16f1604d9fe1.json`;

        const response = yield call(axios.get, url, { baseURL: '/' });

        yield put({
            type: FETCH_WHEELCHAIR_WORKOUTS_FINISHED,
            wheelchairWorkouts: response.data.workouts,
            bodyParts: response.data.bodyParts,
            primaryMuscles: response.data.primaryMuscles,
            goals: response.data.goals,
            sportTypes: response.data.sportTypes,
            difficultyMapper: response.data.difficulty,
            equipment: response.data.equipment,
            receivedAt: Date.now()
        });
    } catch (e) {
        if (locale !== 'en-US') {
            yield call(fetchWheelchairWorkouts, {
                payload: {
                    locale: 'en-US',
                    viewerSocialProfile
                }
            });
        }
    }
}

//watcher
export const workoutsSagas = [
    takeEvery(FETCH_WORKOUTS, fetchWorkouts),
    takeEvery(FETCH_PROVIDER_WORKOUTS, fetchProviderWorkouts),
    takeEvery(FETCH_WHEELCHAIR_WORKOUTS, fetchWheelchairWorkouts)
];
